import View from './CategoryList'
import { connect } from 'react-redux'

const mapStateToProps = state => ({
  locale: state.router.locale,
  isHomePage: state.router.activeRoute.name === 'homepage',
  categories: state.categories.categories,
})

const CategoryList = connect(mapStateToProps)(View)

export default CategoryList
